
export const getFilterButtonsConfig = (isLoading, redirectToSurveyList) => [
  {
    icon: 'arrow_back',
    name: 'Encuestas',
    isDropdown: false,
    dropdownItems: [],
    buttonType: 'button',
    func: redirectToSurveyList
  },
  {
    icon: 'add',
    name: 'Guardar',
    isDropdown: false,
    dropdownItems: [],
    buttonType: 'submit',
    isLoading: isLoading
  }
];